module.exports = __webpack_public_path__ + "img/blob-4.379f4910.png";